import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './store'
import { Provider } from 'react-redux'
import { ThemeProvider} from 'react-bootstrap';
import { MantineProvider } from '@mantine/core';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import './VarelaRound-Regular.ttf';

Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <ThemeProvider  dir="rtl" lang="he" >
    <MantineProvider
    
    theme={{
        // fontWeight: 'normal',
        // fontFamily:"Helvetica",
        widths:{
          xs: '100%',
          sm: '100%',
          md: '90%',
          lg: '60%',
          xl: '60%',

        },
        textAlign:"right",
        fontSizes: {
          xs: '0.7rem',
          sm: '0.9rem',
          md: '1.0rem',
          lg: '1.4rem',
          xl: '1.6rem',
        },
        primaryColor: 'blue',
        primaryShade: 3,
        colors: {
          blue: [
            "#f7fbff",
            "#deebf7",
            "#c6dbef",
            "#9ecae1",
            "#6baed6",
            "#4292c6"


          ],
        },
       
       
      
    }}
  >
      <App />
      </MantineProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
